import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from './WizardInput';
import { Col, Row } from 'react-bootstrap';
import c from 'util/const';
import _ from 'lodash';

const CommissionForm = ({
  register,
  errors,
  setValue,
  signupType = 'individual'
}) => {
  const states = c.states;
  const countries = c.country;
  if (signupType === 'organization') {
    return (
      <>
        <h6 className="text-center">
          Please provide your organization details so we can finish setting up
          your account.
          <br />
          This address should be your business&apos;s primary mailing address.
        </h6>
        <Row className="g-2 mb-3">
          <WizardInput
            type="text"
            errors={errors}
            label="Address 1 *"
            name="address1"
            placeholder=""
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('address1', {
                required: 'Please enter address line 1'
              })
            }}
            setValue={setValue}
          />
          <WizardInput
            type="text"
            errors={errors}
            label="Address 2"
            name="address2"
            placeholder="Optional"
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('address2')
            }}
            setValue={setValue}
          />

          <WizardInput
            type="text"
            errors={errors}
            label="Address 3"
            name="address3"
            placeholder="Optional"
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('address3')
            }}
            setValue={setValue}
          />

          <WizardInput
            type="text"
            errors={errors}
            label="City *"
            name="city"
            placeholder=""
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('city', {
                required: 'Please enter city'
              })
            }}
            setValue={setValue}
          />

          <WizardInput
            type="select-value-label"
            name="state"
            label="State *"
            errors={errors}
            placeholder="Select state"
            options={states}
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('state', {
                required: 'Please select state'
              })
            }}
            setValue={setValue}
          />

          <WizardInput
            type="text"
            errors={errors}
            label="Postal Code *"
            name="postal_code"
            placeholder=""
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('postal_code', {
                required: 'Please enter postal code'
              })
            }}
            setValue={setValue}
          />

          <WizardInput
            type="select-value-label"
            name="country"
            label="Country *"
            errors={errors}
            placeholder="Select country"
            options={countries}
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('country', {
                required: 'Please select country'
              })
            }}
            setValue={setValue}
          />

          <WizardInput
            type="select-value-label"
            name="localtimezone"
            label="Timezone *"
            errors={errors}
            placeholder=""
            options={_.map(c.timezones, t => {
              return {
                name: `${t.name} (${t.zone})`,
                text: t.zone
              };
            })}
            formGroupProps={{ as: Col, sm: 6 }}
            formControlProps={{
              ...register('localtimezone', {
                required: 'Please select timezone'
              })
            }}
            setValue={setValue}
          />
        </Row>
      </>
    );
  }

  return (
    <>
      <h6 className="text-center">
        Please provide us your commission details so we can set up your Notary
        eJournal account.
      </h6>
      <p className="text-center text-info fs--1">
        If you are commissioned in more than one state, you can add additional
        notary commissions later from the account page.
      </p>
      <Row className="g-2 mb-3">
        <WizardInput
          type="text"
          errors={errors}
          label="Commissioned Name *"
          name="commission_name"
          placeholder=""
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            className: 'input-spin-none',
            ...register('commission_name', {
              required: 'Please Enter commissioned Name'
            })
          }}
          setValue={setValue}
        />
        <WizardInput
          errors={errors}
          label="Commission Number"
          name="commission_number"
          placeholder="Number - Optional"
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register('commission_number', {
              required: false
            })
          }}
          setValue={setValue}
        />

        <WizardInput
          errors={errors}
          label="Commissioned County"
          name="county"
          placeholder="County - Optional"
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register('county', {
              required: false
            })
          }}
          setValue={setValue}
        />

        <WizardInput
          type="select-value-label"
          name="state"
          label="Commissioned State *"
          errors={errors}
          placeholder=""
          options={states}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register('state', {
              required: 'Please select commission profile state'
            })
          }}
          setValue={setValue}
        />

        <WizardInput
          label="Commission Expiration"
          type="date"
          name="commission_exp"
          setValue={setValue}
          errors={errors}
          placeholder="Expiration date - Optional"
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            placeholder: 'MM/DD/YYYY',
            ...register('commission_exp', {
              required: false
            })
          }}
          datepickerProps={{
            dateFormat: 'MM/dd/yyyy',
            showMonthYearPicker: false,
            showMonthDropdown: true,
            showYearDropdown: true,
            dropdownMode: 'select',
            yearDropdownItemNumber: 40
          }}
        />

        <WizardInput
          type="select-value-label"
          name="localtimezone"
          label="Timezone *"
          errors={errors}
          placeholder=""
          options={_.map(c.timezones, t => {
            return {
              name: `${t.name} (${t.zone})`,
              text: t.zone
            };
          })}
          formGroupProps={{ as: Col, sm: 6 }}
          formControlProps={{
            ...register('localtimezone', {
              required: 'Please select commission profile timezone'
            })
          }}
          setValue={setValue}
        />
      </Row>
    </>
  );
};

CommissionForm.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  signupType: PropTypes.oneOf(['individual', 'organization'])
};

export default CommissionForm;
